import React from 'react'

const Rating = ({ questionID, value, setValue, amount }) => {
  const stars = []

  for (let i = 0; i < amount; i++) {
    stars.push(
      <i
        key={`rating-${questionID}-${i}`}
        className={`fas fa-star fa-2x${i < amount ? ' pr-2' : ''}`}
        style={{
          color: value >= i + 1 ? '#466ea5' : '#d9d9d9',
          cursor: 'pointer'
        }}
        onClick={() => setValue(questionID, i + 1)}
      ></i>
    )
  }
  return stars
}

export default Rating
